export class BookingFinalConfirmationTemplate {

    constructor(
        public id: number,
        public name: string
    ){}

}
